import { FC } from "react";

import { EditorialModuleImageProps } from "@/components/Editorial2Col/EditorialModuleImage";
import Image from "@/components/ui/Image/Image";
import useMediaQuery from "@/hooks/useMediaQuery";

const TiledImageHorizontal: FC<EditorialModuleImageProps> = ({ entry }) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  return (
    <div className="col-span-2 h-full overflow-hidden">
      <div className="w-full h-full">
        <Image
          src={isMobile ? entry.mobileImage?.url ?? entry.image.url : entry.image.url}
          width={543}
          height={267}
          className="w-full h-full rounded-lg aspect-2-1"
          alt={entry.image.title}
        />
      </div>
    </div>
  );
};
export default TiledImageHorizontal;
